import Vue from 'vue'
// import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap' // Import js file
import 'bootstrap/dist/css/bootstrap.min.css' // Import css file
import VueCarousel from 'vue-carousel'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import moment from 'moment'

window.Vue = Vue
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueAxios, axios)
Vue.use(VueCarousel)
Vue.use(VueSweetalert2)
Vue.config.devtools = true

Vue.filter('dateFormat', function (daraStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(daraStr).format(pattern)
})
Vue.prototype.moment = moment

// Vue.use(VueAnalytics, {
//   id: 'G-MXNRWY8456',
//   router,
//   autoTracking: {
//     pageviewOnLoad: false
//   }
// })
Vue.use(VueGtag, {
  config: { id: 'G-MXNRWY8456' }
})

router.beforeEach(async (to, from, next) => {
  const token = to.query.token

  if (token) {
    const query = { ...to.query }
    delete query.token
    let isTokenLoginSuccess = true

    try {
      await store.dispatch('loginWithToken', Array.isArray(token) ? token[0] : token)
    } catch (error) {
      isTokenLoginSuccess = false
      store.commit('logout')
    }

    if (!isTokenLoginSuccess) {
      next({
        name: 'Home',
        query,
        hash: to.hash,
        replace: true
      })
      return
    }

    const nextRoute = {
      params: to.params,
      query,
      hash: to.hash,
      replace: true
    }

    if (to.name === 'Home') {
      nextRoute.name = 'AI_Book'
    } else if (to.name) {
      nextRoute.name = to.name
    } else {
      nextRoute.path = to.path
    }

    next(nextRoute)
    return
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // console.log(store.state.auth.authorized)
    if (!store.state.auth.authorized) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export { vm }
